import moment from 'moment';
import { Howl, Howler } from 'howler';

import { ConversationStatusList } from '../../assets/ConversationStatus';
import NotificationSound from '../../assets/audio/open-ended.mp3';

const getClientName = (userName, textType, typeofUser) => {
  let client_name = null;
  switch (textType) {
    case 'SMS':
      client_name = typeofUser;
      break;
    case 'TRANSCRIPT':
      client_name = typeofUser;
      break;
    case 'WEBCHAT':
      client_name = `Webchat ${typeofUser}`;
      break;
    default:
      client_name = typeofUser;
  }
  return userName?.trim() || client_name;
};

const getClientPhone = (conversation) => {
  if (conversation.textType === 'WEBCHAT' && conversation.userPhone === 'NA') {
    return conversation.userId || '';
  } else {
    return formatPhoneNumber(conversation.userPhone) || '';
  }
};
const getClientPhoneCleaned = (conversation) => {
  if (conversation.textType === 'WEBCHAT' && conversation.userPhone === 'NA') {
    return conversation.userId || '';
  } else {
    return getCleanedPhone(conversation.userPhone) || '';
  }
};

const getConversationStatus = (conversation) => {
  const action = conversation.action || 'NONE';
  const matchedStatus = ConversationStatusList.find(
    (option) => option.value === action,
  );
  return {
    ...matchedStatus,
    updatedBy: conversation.action_updated_by,
    updatedAt: conversation.action_updated_time,
  };
};

const getclientNameList = (conversation, typeofUser) => {
  let client_names = [];
  let associated_clients = [...conversation.associated_clients];
  if (associated_clients.length === 0) {
    associated_clients.push({ name: conversation.userName });
  }
  associated_clients.map((client) => {
    client_names.push(getClientName(client.name, conversation.textType, typeofUser));
  });
  // client_names = Array.from(new Set(client_names));

  const suffix =
    client_names.length - 2 > 0
      ? ' & ' + (client_names.length - 2).toString() + ' Other'
      : '';
  let users = '';
  let breakdown = client_names.length > 2 ? 2 : client_names.length;
  for (let i = 0; i < breakdown; i++) {
    users += client_names[i] + ', ';
  }
  users = users.substring(0, users.length - 2) + suffix;

  return users;
};

const getclientNameListMeta = (conversation, typeofUser) => {
  let client_names = [];
  let associated_clients = [...conversation.associated_clients];
  if (associated_clients.length === 0) {
    associated_clients.push({ name: conversation.userName });
  }
  associated_clients.map((client) => {
    client_names.push(getClientName(client.name, conversation.textType, typeofUser));
  });
  // client_names = Array.from(new Set(client_names));

  const suffix =
    client_names.length - 1 > 0
      ? ', +' + (client_names.length - 1).toString() + ' more'
      : '';
  let users = '';
  // let breakdown = client_names.length > 3 ? 3 : client_names.length;
  for (let i = 0; i < 1; i++) {
    users += client_names[i] + ', ';
  }
  users = users.substring(0, users.length - 2) + suffix;
  return users;
};

const getNameform = (conversation) => {
  let client_names = [];
  let associated_clients = [...conversation.associated_clients];
  if (associated_clients.length === 0) {
    associated_clients.push({ name: conversation.userName });
  }
  associated_clients.map((client) => {
    if (client.name.trim()) {
      client_names.push(client.name.trim());
    }
  });
  client_names = Array.from(new Set(client_names));

  if (client_names.length > 0) {
    return client_names[0];
  } else {
    return null;
  }
};

const getAnnotations = (conversation, search) => {
  let annotation = [...conversation.tags];
  //  if (
  //    conversation.bookings.length === 0 &&
  //    conversation.associated_clients.length === 0
  //  ) {
  //    annotation.push('NEW');
  //  }
  if (conversation.new_client_created) {
    annotation.push('NEW');
  }
  if (conversation.inference !== 'NONE') {
    annotation.push(conversation.inference);
  }
  if (conversation.tags.includes('IS_LANDLINE')) {
    annotation.push('IS_LANDLINE');
  }
  if (!conversation.tags.includes('USER_RESPONDED')) {
    annotation.push('UNRESPONSIVE');
  }
  if (search) {
    conversation.allBookings.map((booking) => {
      annotation.push(booking.bookingType);
    });
  } else {
    conversation.bookings.map((booking) => {
      annotation.push(booking.bookingType);
    });
  }
  return [...new Set(annotation)];
};

const getTagsForFilter = (conversation, search) => {
  const customtags = conversation?.conversation_tags?.map((tag) => tag.name);
  let annotation = [...conversation.allTags, ...customtags];
  console.log('annotation-->', annotation);
  //  if (
  //    conversation.bookings.length === 0 &&
  //    conversation.associated_clients.length === 0
  //  ) {
  //    annotation.push('NEW');
  //  }
  if (conversation.new_client_created) {
    annotation.push('NEW');
  }
  if (conversation.inference !== 'NONE') {
    annotation.push(conversation.inference);
  }
  if (conversation.tags.includes('IS_LANDLINE')) {
    annotation.push('IS_LANDLINE');
  }
  if (!conversation.tags.includes('USER_RESPONDED')) {
    annotation.push('UNRESPONSIVE');
  }
  if (search) {
    conversation.allBookings.map((booking) => {
      annotation.push(booking.bookingType);
    });
  } else {
    conversation.bookings.map((booking) => {
      annotation.push(booking.bookingType);
    });
  }
  console.log('ALLTAGS', [...new Set(annotation)]);
  return [...new Set(annotation)];
};
const formatPhoneNumber = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  } else {
    return phoneNumberString;
  }
};
const getCleanedPhone = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  // var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  return cleaned;
};

const validatePhoneNumber = (phoneNumberString) => {
  if (phoneNumberString.trim().match(/[!@#$%^&*.?":{}|<>a-zA-Z]/) === null) {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let intlCode = match[1] ? match[1] : '';
      return [intlCode, match[2], match[3], match[4]].join('');
    } else {
      return false;
    }
  } else {
    return false;
  }
};
const isBrandLocation = (location) => {
  if (location && location.studioId && location.brand_ids) {
    if (location.brand_ids.includes(location.studioId)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

const abbrivateString = (abbrivator, limit) => {
  if (abbrivator.length <= limit) {
    return abbrivator;
  }
  return abbrivator.slice(0, limit) + '...';
};

const abbrivateDate = (date) => {
  return moment(date).calendar(null, {
    sameDay: 'ddd, MMM D ([Today])',
    lastDay: 'ddd, MMM D ([Yesterday])',
    lastWeek: 'ddd, MMM D',
    sameElse: 'ddd, MMM D',
  });
};

const getTypeofConversation = (selectedConversation) => {
  switch (selectedConversation.textType) {
    case 'SMS': return 'Direct Text';
      break;
    case 'FORM_SUBMISSION': return 'Lead Engage';
      break;
    case 'TRANSCRIPT': return 'Missed Call';
      break;
    case 'WEBCHAT': return 'Webchat';
      break;
    case 'WEB_TO_TEXT': return 'Web-to-text';
      break;
    case 'WEB_BOOKING': return 'Online Booking';
      break;
    case 'VOICE_CALL': if (selectedConversation.initiatedFor === 'VOICE_CALL' || selectedConversation.initiatedFor === 'INCOMING_VOICE_CALL') {
      return 'Voice Call';
    } else {
      return 'Reminders';
    }
      break;
    default: return selectedConversation.textType;
  }
};

const getOtherStaff = (assignedTo, allAssignmentMap) => {
  const assignmentInfo = allAssignmentMap.filter((assignement) => assignement.assigned_to === assignedTo);
  if (assignmentInfo && assignmentInfo.length > 0 && assignmentInfo[0].location) {
    return {
      firstName: assignmentInfo[0].location.name,
      id: assignedTo,
      lastName: '',
      business_id: assignmentInfo[0].location.id,
    };
  } else {
    return null;
  }
};

const getLogoName = (selected, list, allAssignmentMap) => {
  const assigned_staff = list.filter((staff) => staff.id === selected);
  const staff = assigned_staff.length > 0 ? assigned_staff[0] : (selected ? getOtherStaff(selected, allAssignmentMap) : { firstName: 'NA', lastName: 'NA' });
  if (assigned_staff.length === 0 && selected) {
    return null;
  }
  if (staff.lastName) {
    return staff.firstName.charAt(0) + staff.lastName.charAt(0);
  } else {
    return staff.firstName.substring(0, 2);
  }
};

const getMetricsAutoSent = (total_messages, staff_messages) => {
  const percentage = ((total_messages - staff_messages) * 100) / total_messages;
  return percentage ? roundTheDecimalHeader(percentage) : 0;
};

const roundTheDecimalHeader = function (value) {
  return Math.round(Math.round(value * 100) / 100);
};

const kFormatter = function (num) {
  console.log('num', num);
  if (!num || num < 1) return 0;
  if (Math.abs(num) > 999 && Math.abs(num) < 1000000) {
    return Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k';
  } else if (Math.abs(num) >= 1000000) {
    return Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1)) + 'M';
  } else {
    return Math.round(Math.sign(num) * Math.abs(num));
  }
};

const playNotifcationSound = function () {
  console.log('Play Audio');
  const sound = new Howl({
    src: [NotificationSound],
    autoplay: true,
    loop: false,
    volume: 0.2,
    onend() {
      console.log('Finished!');
    },
  });
  sound.play();
};

export default {
  getClientName,
  getClientPhone,
  getClientPhoneCleaned,
  getConversationStatus,
  getclientNameList,
  getAnnotations,
  getTagsForFilter,
  formatPhoneNumber,
  getCleanedPhone,
  validatePhoneNumber,
  getNameform,
  getclientNameListMeta,
  abbrivateString,
  abbrivateDate,
  getTypeofConversation,
  isBrandLocation,
  getLogoName,
  getOtherStaff,
  getMetricsAutoSent,
  kFormatter,
  playNotifcationSound,
};
